/* eslint-disable react/prop-types */
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import React from 'react';
import { Button, ButtonGroup } from 'react-bootstrap';
import Flex from '../Flex';

export const AdvanceTablePagination = ({
 canPreviousPage,
 canNextPage,
 previousPage,
 nextPage,
 pageCount,
 pageIndex,
 gotoPage
}) => {
 const pageTotal = pageCount - 1;
 const files = Array.from(Array(pageCount > 7 ? 5 : pageCount < 3 ? 0 : pageCount - 2).keys());
 return (
  <Flex alignItems="center" justifyContent="center">
   <ButtonGroup size="sm">
    <Button variant="falcon-primary" onClick={() => previousPage()} disabled={!canPreviousPage}>
     <FontAwesomeIcon icon="chevron-left" className="fs--1" />
    </Button>
    <Button variant={pageIndex === 0 ? 'falcon-primary' : 'falcon-default'} onClick={() => gotoPage(0)}>
     1
    </Button>
    {files.map((page, i) => {
     const pgCount = pageCount - 4;
     const pageNum = i < 2 ? pageIndex - i : i > 2 ? pageIndex + i - 2 : pageIndex;

     if (pageIndex >= pgCount && pageCount > 7) {
      let pgNum = i < 2 ? pgCount - i : i > 2 ? pgCount + i - 2 : pgCount;
      if (pageIndex === pgCount) pgNum = pageNum;

      return (
       <Button
        key={i}
        variant={pageIndex === pgNum ? 'falcon-primary' : 'falcon-default'}
        className={classNames({ 'px-2': !i })}
        disabled={!i}
        onClick={() => gotoPage(pgNum)}
       >
        {!i ? <FontAwesomeIcon icon="ellipsis-h" className="text-success fs--2 align-bottom" /> : pgNum + 1}
       </Button>
      );
     } else if (pageIndex > 3 && pageCount > 7)
      return (
       <Button
        key={i}
        variant={pageIndex === pageNum ? 'falcon-primary' : 'falcon-default'}
        className={classNames({ 'px-2': /0|4/.test(i) })}
        disabled={/0|4/.test(i)}
        onClick={() => gotoPage(pageNum)}
       >
        {/0|4/.test(i) ? <FontAwesomeIcon icon="ellipsis-h" className="text-success fs--2 align-bottom" /> : pageNum + 1}
       </Button>
      );
     else if (pageCount > 7)
      return (
       <Button
        key={i}
        variant={pageIndex === page + 1 ? 'falcon-primary' : 'falcon-default'}
        className={classNames({ 'px-2': i === 4 })}
        disabled={i === 4}
        onClick={() => gotoPage(page + 1)}
       >
        {i === 4 ? <FontAwesomeIcon icon="ellipsis-h" className="text-success fs--2 align-bottom" /> : page + 2}
       </Button>
      );

     return (
      <Button key={i} variant={pageIndex === page + 1 ? 'falcon-primary' : 'falcon-default'} onClick={() => gotoPage(page + 1)}>
       {page + 2}
      </Button>
     );
    })}
    {pageCount > 1 && (
     <Button variant={pageIndex === pageTotal ? 'falcon-primary' : 'falcon-default'} onClick={() => gotoPage(pageTotal)}>
      {pageCount}
     </Button>
    )}
    <Button variant="falcon-primary" onClick={() => nextPage()} disabled={!canNextPage}>
     <FontAwesomeIcon icon="chevron-right" className="fs--1" />
    </Button>
   </ButtonGroup>
  </Flex>
 );
};

export default AdvanceTablePagination;
